import type { StructuredDataContactPoint } from './structuredDataTypes';

/** Default structured data values for the application
 * TODO: Derive some of these dynamically (e.g. organization sameAs links, contact points) instead of hardcoding
 */
export const STRUCTURED_DATA_DEFAULTS = {
  websiteName: 'Onshape',
  // add later when we have a dedicated search results page: 'SearchResultsPage',
  // websiteSearchUrlTemplate: 'https://www.onshape.com/search?query={search_term_string}',
  organization: {
    id: 'https://www.onshape.com/#organization',
    url: 'https://www.onshape.com/',
    name: 'Onshape, a PTC Business',
    parentName: 'PTC',
    parentUrl: 'https://www.ptc.com/',
    sameAs: [
      'https://www.linkedin.com/company/onshape/',
      'https://www.youtube.com/@OnshapeInc',
      'https://www.facebook.com/onshapeInc/',
    ],
    contactPoints: [
      {
        contactType: 'customer support',
        url: 'https://www.onshape.com/en/contact',
        availableLanguage: 'en',
      },
    ] as StructuredDataContactPoint[],
  },
} as const;
